import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialVisitorAccordion } from '../../business/visitor/material-visitor-accordion';
import { MaterialVisitorReason } from '../../business/visitor/material-visitor-reason';
import { MaterialVisitorWidget } from '../../business/visitor/material-visitor-widget';
import { MaterialVisitorHomeAccordionsComponent } from './material-visitor-home-accordions/material-visitor-home-accordions.component';
import { MaterialVisitorHomeMultipleEntryComponent } from './material-visitor-home-multiple-entry/material-visitor-home-multiple-entry.component';
import { MaterialVisitorHomeWidgetsComponent } from './material-visitor-home-widgets/material-visitor-home-widgets.component';

@Component({
    selector: 'ecm-mat-visitor-home-accordion-modulo',
    templateUrl: 'material-visitor-home-accordion-modulo.html',
    styleUrls: ['material-visitor-home-accordion-modulo.css'],
    standalone: true,
    imports: [
        NgClass,
        MaterialVisitorHomeMultipleEntryComponent,
        MaterialVisitorHomeAccordionsComponent,
        MaterialVisitorHomeWidgetsComponent,
        TranslateModule,
    ],
})
export class MaterialVisitorHomeAccordionModuloComponent implements OnInit {
    public i18nPath = 'material.visitor.home.links';

    @Input() public mainPicture?: string;

    @Input() public title: string;

    @Input() public description?: string[];

    @Input() public confirmationLabel?: string;

    @Input() public accessibleConfirmationLabel?: string;

    @Input() public accordions?: MaterialVisitorAccordion[];

    @Input() public accordionTitle?: string;

    @Input() public reason: MaterialVisitorReason;

    @Input() public widgets: MaterialVisitorWidget | MaterialVisitorWidget[] = [];
    public widgetsArray: MaterialVisitorWidget[];

    @Input() public e2e?: string;

    @Input() public isIdentifierLinkDisplayed = true;

    @Input() public entryPoints: any[];

    @Input() public multiplePossibilitiesLabel: string;

    @Output() public visitorHomeLogin = new EventEmitter();

    @Output() public visitorHomeFindIdentifier = new EventEmitter();

    @Output() public visitorButtonClick: EventEmitter<{ zone: string; index: number; href?: string }> =
        new EventEmitter<{
            zone: string;
            index: number;
            href?: string;
        }>();

    /**
     * @inheritDoc
     */
    public ngOnInit(): void {
        // set e2e data tag
        this.e2e = this.e2e || 'e2e-material-visitor-home-accordion-modulo';
        this.widgetsArray = Array.isArray(this.widgets) ? this.widgets : [this.widgets];
    }

    public emitFindIdentifierEvent(): void {
        this.visitorHomeFindIdentifier.emit();
    }

    public emitLoginEvent(event?: string): void {
        this.visitorHomeLogin.emit(event);
    }

    /**
     * Emit event when an accordion or widget button is clicked
     */
    public emitButtonClickEvent(buttonZone: string, buttonIndex: number, href?: string): void {
        this.visitorButtonClick.emit({ zone: buttonZone, index: buttonIndex, href });
    }
}
